import { getRouter } from './get-router';
import { navigateToPath } from './navigate-to-path';
import { urlFor } from './url-for';
/**
 * Navigates to a specific route.
 * @param name - Name of the route.
 * @param params - Route path parameters.
 * @param router - Used router.
 * @returns Navigation success.
 */
export function navigate(name, params, router = getRouter()) {
    const path = urlFor(name, params, router);
    return navigateToPath(path);
}
